import React, { useState } from "react";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import { FaEdit, FaPlus } from "react-icons/fa";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import LanguageTableModalContent from "../ModalContent/LanguageTableModalContent";
import { useGetLanguageList } from "../hook/useSetting";



interface LanguageData {
  languagename: string;
  languagecode: number;
  LanguageId: number;
  CreatedAt: string;
}

const languageDataColumns =(handleRow:(row:any)=>void)=> [ 
  {
    name: "Language Name",
    selector: (row: { languagename: string }) => row.languagename,
    sortable: true,
    width: "200px",
  },
  {
    name: "Language Code",
    selector: (row: { languagecode: string }) => row.languagecode,
    sortable: true,
    width: "200px",
  },
  {
    name: "Action",
    width: "100px",
    cell: (row: any) => (
      <button
        onClick={() =>handleRow(row)}
        className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
        style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
      >
        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
      </button>
    ),
  },
];

 
const LanguageTable = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [status,setStatus]  = useState<string |null>(null);
  
  const [rowData,setRowData]  = useState<LanguageData |null>(null)

  const [filterState,setFiterState] = useState({
    search:''
  })

  const {isLoading,isSuccess,data} = useGetLanguageList({enable:true,params:{
    search:filterState.search
  }}) 

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  
  const handleSearch =(val:string)=>{
     setFiterState((prev:any)=>({
          ...prev,
          search:val
     }))
  }
  
  const  AddLanguage=()=>{
    setStatus('Add');
    setIsModalOpen(true);
  } 

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const handleRow=(row:any)=>{
    setStatus('Edit');
    setRowData(row);
    setIsModalOpen(true); 
    // console.log('handleRow',row);
  }

  return (
    <div className="container mt-3">
      <BasicDataTable

        // onChangePage={(pageNo: number) => { handlePagination(pageNo); }}
        // onChangeRowsPerPage={(newPerPage: any, page: any) => {
        //           handleonChangeRowsPerPage(newPerPage, page)
        //         }}

        handleSearch={(val: any) => {handleSearch(val) }}
        
        paginationTotalRows={!isLoading && data?.rowData.data.recordsTotal || 0}
        Title="Language"
        data={(!isLoading && isSuccess && data?.formatedData) || []}
        columns={languageDataColumns(handleRow)}
        headerContent={
         
          <button
            onClick={AddLanguage}
            className="btn btn-info"
            style={{
              marginRight:'10px',
              borderRadius: "20px",
              padding: "6px 12px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
          <FaPlus /><span>Add Language</span>
          </button>
        }
      />
      <RouteModal
        toggle={toggleModal}
        isOpen={isModalOpen}
        title={status ==="Add" ? "Add Language" :'Update Langugae'}
        size="md"
        content={
          <LanguageTableModalContent
            handleClose={handleClose}
            status={status}
            rowData={rowData}
          />
        }
      />
    </div>
  );
};

export default LanguageTable;
